const $ = window.jQuery;

// Trigger upload on space & enter.
$( '.gf-fileupload-container span[role="button"]' ).on( 'keypress keyup', function( event ) {
	if ( event.which === 32 || event.which === 13 ) {
		event.preventDefault();
		$( this ).parent().find( 'input[type="file"]' ).click();
	}
} );

$( '.gf-fileupload-container span[role="button"]' ).click( function( event ) {
	event.preventDefault();
	$( this ).parent().find( 'input[type="file"]' ).click();
} );

// Handle reset form button.
window.tammanGFHandleReset = function( target ) {
	const form = $( event.target ).closest( 'form' );
	const formId = form[0].id.replace( 'gform_', '' );
	form[0].reset();

	window.requestAnimationFrame( function() {
		form.find( `#gform_target_page_number_${ formId }` ).val( '1' );
		form.trigger( 'submit', [ true ] );
	} );
}
